module.exports = __webpack_public_path__ + "romo_logo_tall.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/romo_logo_tall.jpg
// module id = 858
// module chunks = 0